import { render, staticRenderFns } from "./SalesReportsView.vue?vue&type=template&id=a971acca&"
import script from "./SalesReportsView.vue?vue&type=script&lang=js&"
export * from "./SalesReportsView.vue?vue&type=script&lang=js&"
import style0 from "./SalesReportsView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports